import { Link } from 'react-router-dom';

import type { HomeCardBlock } from "@/types/Home";

import './styles/home-card.scss'

interface Props {
    data: HomeCardBlock
}

function HomeCard({data}: Props) {
    return (
        <Link className="home-card" to={data.link}>
            <div className="home-card__header">
                <img src={data.icon} alt="" />
                <h5 className="home-card__title">
                    { data.title }
                </h5>
            </div>
            <p className="home-card__description">{ data.description }</p>
        </Link>
    )
}

export default HomeCard;